import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-file-icon',
  templateUrl: './files-file.component.html'
})
export class FilesFileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
